import { Component, EventEmitter, Input, Output } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss'],
})
/**
 * Button atom. can be normal, stroked, disabled, wrapped or bold
 */
export class PrimaryButtonComponent {
  private _stroked: boolean = false;
  private _disabled: boolean = false;
  private _wrapped: boolean = false;
  private _bold: boolean = false;
  private _v2Full: boolean = false;
  private _v2Outlined: boolean = false;
  private _critical: boolean = false;

  @Output() clickAction = new EventEmitter<any>();
  @Input() type?: string;
  @Input() abstractControl?: AbstractControl;

  /**
   * Whether this button is disabled or not
   */
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  /**
   * Sets this button as disabled
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set disabled(value: any) {
    this._disabled = coerceBooleanProperty(value);
  }

  /**
   * Whether this button is stroked or not
   */
  @Input()
  get stroked(): boolean {
    return this._stroked;
  }

  /**
   * Sets this button as stroked
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set stroked(value: any) {
    this._stroked = coerceBooleanProperty(value);
  }

  /**
   * Emits click action event for underlying material button
   */
  emitClick() {
    this.clickAction.emit();
  }

  /**
   * If this button should be disabled or not
   * @return {boolean}
   */
  isDisabled(): boolean {
    return (
      this.disabled ||
      (Boolean(this.abstractControl) && !this.abstractControl?.valid)
    );
  }

  /**
   * Whether this button is wrapped or not
   */
  @Input()
  get wrapped(): boolean {
    return this._wrapped;
  }

  /**
   * Sets this button as wrapped
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set wrapped(value: any) {
    this._wrapped = coerceBooleanProperty(value);
  }

  /**
   * Whether the font-weight is bold or not
   */
  @Input()
  get bold(): boolean {
    return this._bold;
  }

  /**
   * Sets the font-weight as bold
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set bold(value: any) {
    this._bold = coerceBooleanProperty(value);
  }

  /**
   * Whether the critical action or not
   */
  @Input()
  get critical(): boolean {
    return this._critical;
  }

  /**
   * Sets the critical action color
   * @param {any} value value might be any type, and it is coerced into a boolean
   */
  set critical(value: any) {
    this._critical = coerceBooleanProperty(value);
  }

  /**
   * Whether the style is v2 or not
   */
  @Input()
  get v2Full(): boolean {
    return this._v2Full;
  }

  /**
   * Sets the style as v2
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set v2Full(value: any) {
    this._v2Full = coerceBooleanProperty(value);
  }

  /**
   * Whether the style is v2 or not
   */
  @Input()
  get v2Outlined(): boolean {
    return this._v2Outlined;
  }

  /**
   * Sets the style as v2
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set v2Outlined(value: any) {
    this._v2Outlined = coerceBooleanProperty(value);
  }
}
